import {obtainPlanList} from "JQueryScripts/data-layer-handlers/plan-obtainer";
import {dataLayerPush} from "JQueryScripts/data-layer-handlers/data-layer-push";

export const handlePricePageLoad = async () => {
    if (window.isTariffsLoaded === undefined) {
        return;
    }

    const itemList = await obtainPlanList();

    dataLayerPush(itemList);
};